import gql from 'graphql-tag'

export const acceptanceDocQuery = type => gql`
  query GetAcceptanceDoc {
    acceptanceDocument(type: "${type}")
    { type, name, id, url }
  }
`
